export const SCOPES = [
  {
    value: 'AT17',
    year: 2017,
  },
  {
    value: 'AT18',
    year: 2018,
  },
  {
    value: 'AT19',
    year: 2019,
  },
  {
    value: 'AT20',
    year: 2020,
  },
  {
    value: 'AT21',
    year: 2021,
  },
];
